import { useDispatch } from 'react-redux';
import { DataTestId, TextKey } from '@mews-commander/enums';
import { Amount } from '@mews-commander/types';
import { Button, Icon, IconName, ListItem, SplitButton } from '@optimus-web/core';
import { LocalizedText, useScope, withFeatureFlagService, FeatureFlagServiceProps } from '@mews/framework';
import { canCurrentProfileIssueInvoices } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { useCommanderSelector } from '@mews-commander/utils';
import { openCreateProforma, openIssueInvoice } from '../../actions/bills';
import { isBillInvoiceable } from '../../ducks/billing';
import { isAnythingSelected } from '../../ducks/billItems';

interface InvoiceDropDownProps {
    amount?: Amount;
    billId: string;
}

const InvoiceDropDown: React.FC<InvoiceDropDownProps & FeatureFlagServiceProps> = ({
    amount,
    billId,
    featureFlagService,
}) => {
    const dispatch = useDispatch();
    const scope = useScope();
    const canIssueInvoice = useCommanderSelector((state) => canCurrentProfileIssueInvoices(state));
    const isInvoiceable = useCommanderSelector((state) =>
        isBillInvoiceable(state, { billId, amount, featureFlagService })
    );
    const disabled = useCommanderSelector((state) => isAnythingSelected(state, { scope }));

    const onIssueInvoice = () => dispatch(openIssueInvoice({ billId, scope }));
    const onCreateProforma = () => dispatch(openCreateProforma({ billId, scope }));
    return canIssueInvoice && isInvoiceable ? (
        <SplitButton
            label={<LocalizedText textKey={TextKey.IssueInvoice} />}
            variant="tertiary"
            onClick={onIssueInvoice}
            disabled={disabled}
            data-test-id={DataTestId.BillingInvoiceButton}
            wide
        >
            <ListItem
                primaryText={<LocalizedText textKey={TextKey.IssueProforma} />}
                leftIcon={<Icon value={IconName.BillsInvoices} />}
                onClick={onCreateProforma}
                data-test-id={DataTestId.BillingProformaInvoice}
            />
        </SplitButton>
    ) : (
        <Button onClick={onCreateProforma} icon={IconName.BillsInvoices} type="submit">
            <LocalizedText textKey={TextKey.IssueProforma} />
        </Button>
    );
};

export default withFeatureFlagService(InvoiceDropDown);
